import React from 'react';
import styled from 'styled-components';
import theme from '../theme';
import Typo from '../Typo';

const Badge = styled.span`
  background: ${theme.colors.SECONDARY};
  padding: 1px 6px;
  border-radius: 3px;
`;

const BetaBadge = ({ label }) => {
  return (
    <Badge>
      <Typo.Info $caps color={theme.colors.NEUTRAL_0} fontWeight={700} c>
        {label}
      </Typo.Info>
    </Badge>
  );
};

export default BetaBadge;
